export const GRID_HEIGHT_OFFSET_PRESETS = {
  list: { withFilters: undefined, withoutFilters: 120 },
  kanban: { withFilters: 270, withoutFilters: 240 },
};

const getGridHeightOffset = (hasFilters, offset = 'list') => {
  const { withFilters, withoutFilters } =
    typeof offset === 'string'
      ? GRID_HEIGHT_OFFSET_PRESETS[offset] || GRID_HEIGHT_OFFSET_PRESETS.list
      : offset;

  return hasFilters ? withFilters : withoutFilters;
};

export default getGridHeightOffset;
